import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { useReturnSummary } from '../useReturnSummary';
import { useCountry } from '../../components/CountrySelector';
import { REQUEST_RETURN_MUTATION } from './requestReturnMutation.rest';

export const useRequestReturnMutation = (orderNumber: string) => {
  const { country } = useCountry();
  const { returnSummary } = useReturnSummary({ orderNumber });
  const [mutate, { loading, error }] = useMutation(REQUEST_RETURN_MUTATION);

  const handleRequest = useCallback(() => {
    if (!returnSummary) return Promise.reject('useRequestReturnMutation: return summary not found');

    if (returnSummary.attributes.returnMethodId === null) {
      return Promise.reject('useRequestReturnMutation: returnMethodId not found');
    }

    return mutate({
      variables: {
        orderId: returnSummary.id,
        input: {
          data: {
            type: 'orders',
            id: returnSummary.id,
            action_type: 'request_return',
            attributes: {
              country_code: country.alpha2Code,
              return_method_id: returnSummary.attributes.returnMethodId,
              return_option_id: returnSummary.attributes.returnOptionId,
              return_reason_hash: returnSummary.attributes.returnReasonHash
            }
          }
        }
      }
    });
  }, [country, mutate, returnSummary]);

  return [handleRequest, { loading, error }] as const;
};
